<template>
  <div class="mcf-window">
    <div class="mcf-header">
      <div class="mcf-header-left">
        <div class="mcf-header-left-menu">
          <i class="fa fa-grip"></i>
        </div>
        <div class="mcf-header-left-title">
          <label>{{title}}</label>
        </div>
      </div>
      <div class="mcf-header-center">
        <div class="mcf-search">
          <div class="mcf-search-icon">
            <i class="fa fa-search"></i>
          </div>
          <div class="mcf-search-content">
            <input type="text" placeholder="Rechercher">
          </div>
        </div>
      </div>
      <div class="mcf-header-right">
        <ul>
          <li><label>{{state}}</label></li>
          <li><i class='fa fa-user'></i></li>          
        </ul>
      </div>
    </div>
    <div class="mcf-appwindow">
      <div class="mcf-ribbon">
        <div class="mcf-ribbon-left">
          <div class="mcf-ribbon-group" v-if="!is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button class="mcf-ribbon-button-new">
                <i class="fa fa-plus"></i>
                <label>Nouveau</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Client</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_new" class="mcf-ribbon-button-new">
                <i class="fa fa-plus"></i>
                <label>Nouveau</label>
              </button>
              <button @click="bt_edit" class="mcf-ribbon-button-large">
                <i class="fa fa-copy"></i>
                <label>Dupliquer</label>
              </button>
              <button @click="bt_edit" class="mcf-ribbon-button-large">
                <i class="fa fa-edit"></i>
                <label>Modifier</label>
              </button>
              <button @click="bt_print" class="mcf-ribbon-button-large">
                <i class="fa fa-print"></i>
                <label>Imprimer</label>
              </button>
              <button @click="bt_delete" class="mcf-ribbon-button-large">
                <i class="fa fa-trash"></i>
                <label>Supprimer</label>
              </button>              
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Produit</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active && form.product_type=='STD'">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_qty_in(form.id)" class="mcf-ribbon-button-large">
                <i class="fa fa-arrow-down"></i>
                <label>Entrée</label>
              </button>
              <button @click="bt_qty_out(form.id)" class="mcf-ribbon-button-large">
                <i class="fa fa-arrow-up"></i>
                <label>Sortie</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Stock</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_attribute_generate" class="mcf-ribbon-button-large">
                <i class="fa fa-plus"></i>
                <label>Générer</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Produit variable</label>
            </div>
          </div>
        </div>
        <div class="mcf-ribbon-right">
          <div class="mcf-ribbon-group">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_close" class="mcf-ribbon-button-large">
                <i class="fa fa-close"></i>
                <label>Fermer</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Application</label>
            </div>
          </div>
        </div>
      </div>
      <div class="mcf-appwindow-content">
        <div class="mcf-page" v-if="is_form_active">
          <div class="mcf-page-line-entete">
            <div @click="bt_edit(form)" class="prod-header  mcf-page-line-edit">
              <h1>{{form.reference}}</h1>
              <label>{{form.label}}</label>
              <label>{{form.family}} - {{form.subfamily}} - {{form.brand}}</label>
              <label><strong>Prix de vente : {{$filters.money(form.selling_price,lang)}}</strong></label>
            </div>
            <div @click="bt_upload_logo(form.id)" class="prod-logo mcf-page-line-edit">
              <div v-if="form.logo==''" class="prod-logo-empty">
                <div>
                  <i class='fa fa-image'></i>
                  <label>Insérer un logo</label>
                </div>
              </div>
              <div v-if="form.logo!=''" class="prod-logo-content" style="height:100px;">
                <img :src="form.logo">
              </div>
            </div>
          </div>
          <div class="mcf-page-line-3" v-if="form.product_type=='STD'">
            <div class="prod-mcf-page-line-cell">
              <label>Quantité en magasin</label>
              <span v-if="form.is_qty_managed==1">{{qty_agency}}</span>
              <span v-if="form.is_qty_managed==0"><i class="fa fa-ban"></i></span>
            </div>
            <div class="prod-mcf-page-line-cell">
              <label>Quantité en ligne</label>
              <span v-if="form.is_qty_managed==1">{{qty_web}}</span>
              <span v-if="form.is_qty_managed==0"><i class="fa fa-ban"></i></span>
            </div>            
            <div class="prod-mcf-page-line-cell">
              <label>Quantité totale</label>
              <span v-if="form.is_qty_managed==1">{{qty_total}}</span>
              <span v-if="form.is_qty_managed==0"><i class="fa fa-ban"></i></span>
            </div>
          </div>
          <div class="mcf-page-line-1" style="margin-top:30px;" v-if="form.product_type=='VAR'">
            <div class="mcf-page-line-title">
              <h1><i class='fa fa-refresh'></i> Produits variants</h1>
            </div>
            <table class="mcf-table-salelines" style="margin-top:10px;">
              <thead>
                <tr>
                  <th style="width:32px;"></th>
                  <th>Photo</th>
                  <th>Produit</th>
                  <th>Quantité en magasin</th>
                  <th>Quantité en ligne</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody v-if="form.is_qty_managed==1">
                <tr v-for="s of form.lists.variants" :key="s.id">
                  <td style="width:32px;text-align:center;"><div @click="bt_edit_variant(s)"><i class="fa fa-edit"></i></div></td>
                  <td  @click="bt_upload_logo(s.id)">
                    <div v-if="s.logo==''" class="prod-logo-empty">
                      <div>
                        <i class='fa fa-image'></i>
                        <label>Insérer un logo</label>
                      </div>
                    </div>
                    <div v-if="s.logo!=''" class="prod-logo-content" style="height:100px;">
                      <img :src="s.logo">
                    </div>
                  </td>
                  <td style="padding:5px;text-align:left;font-weight:bold;">
                    <label v-if="s.field1!=''" style="display:inline-block;">{{ s.field1 }}</label>
                    <label v-if="s.field2!=''" style="display:inline-block;padding-left:4px;">- {{ s.field2 }}</label>
                    <label v-if="s.field3!=''" style="display:inline-block;padding-left:4px;">- {{ s.field3 }}</label>
                    <label v-if="s.field4!=''" style="display:inline-block;padding-left:4px;">- {{ s.field4 }}</label>
                  </td>
                  <td style="padding:5px;text-align:left;width:80px;text-align:center;">{{s.qtystore}}</td>
                  <td style="padding:5px;text-align:left;width:80px;text-align:center;">{{s.qtyweb}}</td>
                  <td>
                    <ul class="mcf-table-buttons">
                      <li><button @click="bt_qty_in(s.id)"><i class="fa fa-arrow-down"></i></button></li>
                      <li><button @click="bt_qty_out(s.id)"><i class="fa fa-arrow-up"></i></button></li>
                      <li><button><i class="fa fa-arrow-right-arrow-left"></i></button></li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="form.is_qty_managed==1 && form.lists.movements.length==0">
                <tr>
                  <td colspan="6" style="text-align:center;padding:20px;">Vous n'avez pas de mouvements pour ce produit</td>
                </tr>
              </tbody>
              <tbody v-if="form.is_qty_managed==0">
                <tr>
                  <td colspan="6" style="text-align:center;padding:20px;">Vous n'avez pas activé la gestion des stocks pour ce produit</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mcf-page-line-1" style="margin-top:30px;">
            <div class="mcf-page-line-title">
              <h1><i class='fa fa-refresh'></i> Mouvements</h1>
            </div>
            <table class="mcf-table-salelines" style="margin-top:10px;">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Information</th>
                  <th>Entrée</th>
                  <th>Sortie</th>
                  <th>Localité</th>
                </tr>
              </thead>
              <tbody v-if="form.is_qty_managed==1 && form.product_type=='STD'">
                <tr v-for="s of form.lists.movements" :key="s.id">
                  <td style="padding:5px;text-align:center;">{{$filters.mdate(s.date_movement,account.lang)}}</td>
                  <td style="padding:5px;text-align:left;">{{s.label}}</td>
                  <td style="padding:5px;text-align:center;" class="mcf-table-salelines-number">{{$filters.number(s.qty_in,account.lang)}}</td>
                  <td style="padding:5px;text-align:center;" class="mcf-table-salelines-number">{{$filters.number(s.qty_out,account.lang)}}</td>
                  <td style="padding:5px;text-align:left;">{{s.locality}}</td>
                </tr>
              </tbody>
              <tbody v-if="form.is_qty_managed==1 && form.product_type=='STD' && form.lists.movements.length==0">
                <tr>
                  <td colspan="6" style="text-align:center;padding:20px;">Vous n'avez pas de mouvements pour ce produit</td>
                </tr>
              </tbody>
              <tbody v-if="form.is_qty_managed==0">
                <tr>
                  <td colspan="6" style="text-align:center;padding:20px;">Vous n'avez pas activé la gestion des stocks pour ce produit</td>
                </tr>
              </tbody>              
              <tbody v-if="form.is_qty_managed==1 && form.product_type=='VAR'">
                <tr>
                  <td colspan="6" style="text-align:center;padding:20px;">L'historique des produits variants n'est pas disponible</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <products_edit v-if="app_action=='edit'" :account="account" :product="form_tmp" :cancel="evt_edit_cancel" :save="evt_edit_save"></products_edit>
    <products_movement v-if="app_action=='movement'" :account="account" :movement="form_tmp" :cancel="evt_edit_cancel" :save="evt_movement_save"></products_movement>
    <uploadfilebox v-if="app_action=='upload'" :setting="dialog_setting"></uploadfilebox>
    <pdfbox v-if="app_action=='print'" :setting="dialog_setting" :close="evt_edit_cancel"></pdfbox>
    <dialogbox v-if="dialog_show" :setting="dialog_setting"></dialogbox>
    <loadingbox v-if="loading"></loadingbox>
  </div>
</template>

<script>
import apiaccount from "../../core/data/account";
import tools from "../../core/data/tools";
import translation from "../../core/data/lang";
import apiproduct from "../../core/data/product";
import dialogbox from "../../core/controls/ui-dialogbox";
import loadingbox from "../../core/controls/ui-loadingbox";
import pdfbox from "../../core/controls/ui-pdfbox";
import uploadfilebox from "../../core/controls/ui-uploadfilebox";
import products_edit from "./products-edit.vue";
import products_movement from "./products-movement.vue";
import { DateTime } from "luxon";

export default {
  components:{ 
    dialogbox,loadingbox,pdfbox,uploadfilebox,products_edit,products_movement
  },
  data(){
    return {
      loading:false,
      lang:'fr-FR',
      dialog_show:false,
      dialog_setting:{},
      app_action:'',
      title:'Produits',
      account:{},
      logo:"",
      form:{},
      form_tmp:{}
    }
  },
  computed: {
    is_form_active: function(){
      return (JSON.stringify(this.form) != '{}');
    },
    qty_web: function(){
      var total = 0;
      for(var m of this.form.lists.movements.filter(x=>x.locality=='WEB')){
        total += (m.qty_in - m.qty_out);
      }
      return total;
    },
    qty_agency: function(){
      var total = 0;
      for(var m of this.form.lists.movements.filter(x=>x.locality=='STORE')){
        total += (m.qty_in - m.qty_out);
      }
      return total;
    },
    qty_total: function(){
      var total = 0;
      for(var m of this.form.lists.movements){
        total += (m.qty_in - m.qty_out);
      }
      return total;
    },
    state:function(){
      var info = "";
      if (this.form.is_qty_managed==1 && this.qty_total<=0){
        info = "Rupture de stock";
      }
      return info;
    },
    lg: function(){
      return translation.get(this.lang);
    }
  },
  created: async function(){
    var tmain = this;
    tmain.loading = true;
    tools.set_title('Macrofox - Produits');
    tools.set_background('light');
    tools.set_theme('red');
    var pkg = await apiaccount.info();
    if (pkg.code==0){
      tmain.account = pkg.data;
      if (localStorage.getItem("id")!=undefined){
        var pget = await apiproduct.get(localStorage.getItem("id"));
        if (pget.code==0){
          tmain.form = pget.data;
          tmain.loading = false;
        }
      }else{
        tmain.$router.push({path:'/home'});
      }
    }else{
      tmain.$router.push({path:'/'});
    }
  },
  methods:{
    change_theme: async function(){
      this.account.theme = (this.account.theme=='light' ? 'dark' : 'light');
      var pkg = await apiaccount.update(this.account);
      if (pkg.code==0){
        tools.set_background(this.account.theme);
      }      
    },
    bt_new: async function(){
      var tmain = this;
      tmain.dialog_setting = {
        icon:'fa fa-plus',
        title:'Nouveau',
        message:'Voulez-vous créer un produit ?',
        buttons:[
          {
            label:'Oui',
            fx:async function(){
              var pkg = await apiproduct.new();
              if (pkg.code==0){
                tmain.form = pkg.data;
                tmain.form_tmp = {};
                tmain.dialog_setting = {};
                tmain.dialog_show=false;
                tmain.logo ="";
                localStorage.setItem("id",tmain.form.id);
              }
            }
          },
          {
            label:'Non',
            fx:function(){
              tmain.dialog_show=false;
            }
          }
        ]
      };
      tmain.dialog_show=true;
    },
    bt_edit: function(o){
      var tmain = this;
      tmain.form_tmp = Object.assign({},o);
      tmain.app_action="edit";
    },
    bt_edit_variant: function(o){
      var tmain = this;
      tmain.form_tmp = Object.assign({},o);
      tmain.form_tmp.lists = tmain.form.lists;
      tmain.app_action="edit";
    },
    bt_print: async function(){
      var tmain = this;
      tmain.loading = true;
      var pkgfile = await apiproduct.print('PRODUCT',tmain.form.id);
      var fileURL = window.URL.createObjectURL(new Blob([pkgfile],{ type: 'application/pdf' }));
      tmain.loading=false;
      tmain.app_action = 'print';
      tmain.dialog_setting = {
        icon:'fa fa-print',
        title:tmain.form.company,
        data:fileURL,
        buttons:[]
      };
    },
    bt_delete:async function(){
      var tmain = this;
      tmain.dialog_setting = {
        icon:'fa fa-trash',
        title:'Supprimer',
        message:'Voulez-vous supprimer ce produit '+tmain.form.reference+' ?',
        buttons:[
          {
            label:'Oui',
            fx:async function(){
              var pkg = await apiproduct.delete([{id:tmain.form.id}]);
              if (pkg.code==0){
                if (pkg.data.length>0){
                  alert('impossible de supprimer ce client');
                }else{
                  tmain.form = {};
                  tmain.form_tmp = {};
                  tmain.dialog_setting = {};
                  localStorage.clear();
                  tmain.logo = "";
                  tmain.dialog_show=false;
                }
              }
            }
          },
          {
            label:'Non',
            fx:function(){
              tmain.dialog_show=false;
            }
          }
        ]
      };
      tmain.dialog_show=true;
    },
    bt_qty_in: function(id){
      var tmain = this;
      tmain.form_tmp = {id:id,direction:'in',qty_in:1,qty_out:0,date_movement:DateTime.now().toFormat('yyyy-MM-dd'),label:'',locality:'STORE'};
      tmain.app_action="movement";
    },
    bt_qty_out: function(id){
      var tmain = this;
      tmain.form_tmp = {id:id,direction:'out',qty_in:0,qty_out:1,date_movement:DateTime.now().toFormat('yyyy-MM-dd'),label:'',locality:'STORE'};
      tmain.app_action="movement";
    },
    bt_attribute_generate: async function(){
      var tmain = this;
      tmain.loading = true;
      var pkg = await apiproduct.attribute_generate(tmain.form.id);
      if (pkg.code==0){
        var pkgget = await apiproduct.get(tmain.form.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;
        }else{
          console.log('error');
        }
      }else{
        console.log('error');
      }
      tmain.loading = false;
      
    },
    bt_close: function(){
      var tmain = this;
      tmain.$router.push({path:'/home'});
    },
    bt_upload_logo: async function(zid){
      var tmain = this;
      var dlg = {
        icon:'fa fa-info-circle',
        extension:'image/*',
        title:'Veuillez insérer une image',
        id:zid,
        change:async function(zid,arrayfile,file){
          await apiproduct.file_upload(zid,file);
          var apiget = await apiproduct.get(tmain.form.id);
          if (apiget.code==0){
            tmain.form = apiget.data;
          }
          tmain.dialog_setting = {};
          tmain.app_action = '';
        },
        cancel:function(){
          tmain.dialog_setting = {};
          tmain.app_action = '';
        }
      };
      tmain.dialog_setting = dlg;
      tmain.app_action = 'upload';
    },
    evt_edit_cancel:function(){
      this.form_tmp={};
      this.app_action='';
    },
    evt_edit_save: async function(item){
      var tmain = this;
      tmain.loading = true;
      tmain.form_tmp = {};
      tmain.app_action = "";
      var pkg = await apiproduct.save(item);
      if (pkg.code==0){
        var pkgget = await apiproduct.get(item.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;          
        }else{
          console.log('error');
        }
      }else{
        console.log('error');
      }
      tmain.loading = false;
    },
    evt_movement_save: async function(item){
      var tmain = this;
      tmain.loading = true;
      tmain.form_tmp = {};
      tmain.app_action = "";
      var pkg = await apiproduct.movement_new(item.id,item.date_movement,item.qty_in,item.qty_out,item.label,item.locality);
      if (pkg.code==0){
        var pkgget = await apiproduct.get(tmain.form.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;
        }else{
          console.log('error');
        }
      }else{
        console.log('error');
      }
      tmain.loading = false;
    }
  }
}
</script>

<style scoped>

.prod-header{
    padding:20px;
    text-align:left;
}

.prod-header>h1{
    font-size:20px;
    color:var(--C1);
}

.prod-header>label{
    font-size:12px;
}

.prod-logo{
  height: 100%;
  width:100%;
}

.prod-logo-empty{
  border:solid 1px #ddd;
  border-radius: 5px;
  width:calc(100% - 40px);
  height:calc(100% - 40px);
  margin-right:20px;
  margin-left:20px;
  margin-top:20px;
  text-align:center;
  min-height:70px;
  display:grid;
  align-items: center;
}

.prod-logo-empty i{
  color:var(--C2);
  /* margin-top:20px; */
}

.prod-logo-empty label{
  font-size:12px;
}

.prod-logo-content{
  border:solid 1px #ddd;
  border-radius: 5px;
  width:calc(100% - 40px);
  height:calc(100% - 40px);
  margin-right:20px;
  margin-left:20px;
  margin-top:20px;
  text-align:center;
}

.prod-logo-content>img{
  width: auto;
  height: 100%;
  max-width: 180px;
  object-fit: contain;
}

.prod-mcf-page-line-cell{
  background-color:var(--C3);
  border:solid 1px var(--C2);
  border-radius:5px;
  margin:20px;
  padding-bottom:7px;
  display:grid;
  grid-template-rows: 30px auto;
}

.prod-mcf-page-line-cell>label{
  align-self: center;
  justify-self: center;  
}

.prod-mcf-page-line-cell>span{
  align-self: center;
  justify-self: center;
  font-size:20px;
  color:var(--C2);
}

</style>